module.exports = __webpack_public_path__ + "img/组 2@2x.1e1c24dc.png";